import React from "react";

import LogoAndIco from "../Header/LogoAndIco";
import SideBar from "./Sidebar";
import classes from "./Modal.module.css";
import Aux from "../../hoc/Aux";

export default function Modal(props) {
  const url = window.location.pathname;
  let class_name = [classes.Modal];
  if (url === "/watch" && props.extraClass) {
    class_name.push(classes.ShowModal);
  }
  if (props.extraClass) class_name.push(classes.Show);
  return (
    <Aux>
      <div className={class_name.join(" ")} onClick={props.toggleSideBar} />
      <div>
        <LogoAndIco
          toggleSideBar={props.toggleSideBar}
          country={props.country}
        />
        <div style={{ borderTop: "1px solid #dcdcdc" }}>
          <SideBar />
        </div>
      </div>
    </Aux>
  );
}
